module.exports = __webpack_public_path__ + "static/media/md-code.6313a2f3.svg";